import React from 'react'
import PropTypes from 'prop-types'

import useStyles from './tag.style'

const Tag = props => {
  const classes = useStyles(props)

  const { text } = props

  return (
    <span className={classes.text}>{text}</span>
  )
}

Tag.defaultProps = {
  backgroundColor: 'whitesmoke',
  borderRadius: 4,
  color: '#4a4a4a',
  isUpperCased: true,
  size: 'normal',
  text: ''
}

Tag.propTypes = {
  backgroundColor: PropTypes.string,
  borderRadius: PropTypes.number,
  color: PropTypes.string,
  isUpperCased: PropTypes.bool,
  size: PropTypes.oneOf(['normal', 'small', 'medium', 'large']),
  text: PropTypes.string
}

export default Tag
